export { default as GeoLocationDisplay } from './GeoLocationDisplay.component.jsx';
